export default __webpack_public_path__ + "static/invimatic-help-you-ccb97201f979c0846f8ed37b5c04e8c3.png";